// src/components/GoogleCallback.js
import React, { useEffect } from 'react';
import { googleApiConfig } from '../config/googleConfig';

const GoogleCallback = () => {
    useEffect(() => {
        const handleGoogleCallback = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const code = urlParams.get('code');
                const error = urlParams.get('error');

                if (error) {
                    throw new Error(`Google OAuth error: ${error}`);
                }

                if (!code) {
                    throw new Error('No authorization code received');
                }

                // Exchange code for tokens
                const tokenResponse = await fetch(`${googleApiConfig.tokenEndpoint}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                        client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
                        code: code,
                        grant_type: 'authorization_code',
                        redirect_uri: window.location.origin + '/google-callback',
                    }),
                });

                const tokenData = await tokenResponse.json();

                if (!tokenResponse.ok) {
                    throw new Error(`Token exchange failed: ${tokenData.error_description || tokenData.error}`);
                }

                // Get user info
                const userResponse = await fetch(`${googleApiConfig.userInfoEndpoint}?access_token=${tokenData.access_token}`);
                const userData = await userResponse.json();

                if (!userResponse.ok) {
                    throw new Error(`Failed to get user info: ${userData.error_description || userData.error}`);
                }

                // Send data back to parent window
                if (window.opener) {
                    window.opener.postMessage({
                        type: 'GOOGLE_AUTH_SUCCESS',
                        user: userData,
                        accessToken: tokenData.access_token,
                        idToken: tokenData.id_token,
                    }, window.location.origin);
                }

                // Close the popup
                window.close();

            } catch (error) {
                console.error('Google OAuth callback error:', error);

                // Send error back to parent window
                if (window.opener) {
                    window.opener.postMessage({
                        type: 'GOOGLE_AUTH_ERROR',
                        error: error.message,
                    }, window.location.origin);
                }

                // Close the popup
                window.close();
            }
        };

        handleGoogleCallback();
    }, []);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div style={{ textAlign: 'center' }}>
                <h2>Completing Google Sign-In...</h2>
                <p>Please wait while we complete your authentication.</p>
                <div style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #db4437',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '20px auto'
                }}></div>
                <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
            </div>
        </div>
    );
};

export default GoogleCallback;